import {Fillable, Path, PrimaryKey, UploadRestModel} from 'ng-rest-model';
import {HasId, Timestamped} from '../../shared/interfaces';

@Path('sermons')
export class Sermon extends UploadRestModel<Sermon> implements HasId, Timestamped {

    @PrimaryKey()
    id: number;

    @Fillable()
    date: string;

    @Fillable()
    preacher: string;

    @Fillable()
    title: string;

    @Fillable()
    file: string;

    created_at: string;
    updated_at: string;
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/classes/sermon.ts